import React from "react";
import { motion } from "motion/react";

function NavigationItem({ icon, label, isActive, handleClick }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        maxWidth: "250px",
        gap: "8px",
      }}
    >
      {isActive && (
        <motion.div
          layoutId="active-sidebar-indicator"
          style={{
            width: "9px",
            height: "45px",
            flexShrink: "0",
            borderRadius: "4px",
            background: "#007BFF",
          }}
          transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
        />
      )}
      {!isActive && (
        <div
          style={{
            width: "9px",
            height: "45px",
            flexShrink: "0",
            borderRadius: "4px",
            background: "#FFF",
          }}
        />
      )}
      {isActive && (
        <motion.button
          layoutId="active-sidebar-button"
          onClick={handleClick}
          whileTap={{ scale: 0.9 }}
          style={{
            position: "relative",
            overflow: "hidden",
            display: "flex",
            width: "100%",
            maxWidth: "250px",
            gap: "20px",
            alignItems: "center",
            padding: "12px 26px",
            backgroundColor: "rgba(0, 123, 255, 1)",
            color: "rgba(255, 255, 255, 1)",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            font: "500 14px Montserrat, sans-serif",
            whiteSpace: "nowrap",
            letterSpacing: "0",
            "&:focus": {
              outline: "2px solid rgba(0, 123, 255, 0.5)",
              outlineOffset: "2px",
            },
          }}
          transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
        >
          <img
            src={icon}
            alt=""
            loading="lazy"
            style={{
              aspectRatio: "1",
              objectFit: "contain",
              objectPosition: "center",
              width: "20px",
              filter: "brightness(0) invert(1)",
            }}
          />
          <span>{label}</span>
        </motion.button>
      )}
      {!isActive && (
        <motion.button
          onClick={handleClick}
          whileTap={{ scale: 0.9 }}
          style={{
            position: "relative",
            overflow: "hidden",
            display: "flex",
            width: "100%",
            maxWidth: "250px",
            gap: "20px",
            alignItems: "center",
            padding: "12px 26px",
            backgroundColor: "rgba(255, 255, 255, 1)",
            color: "rgba(57, 62, 67, 1)",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            font: "500 14px Montserrat, sans-serif",
            whiteSpace: "nowrap",
            letterSpacing: "-1px",
            "&:focus": {
              outline: "2px solid rgba(0, 123, 255, 0.5)",
              outlineOffset: "2px",
            },
          }}
        >
          <img
            src={icon}
            alt=""
            loading="lazy"
            style={{
              aspectRatio: "1",
              objectFit: "contain",
              objectPosition: "center",
              width: "20px",
              filter: "none",
            }}
          />
          <span>{label}</span>
        </motion.button>
      )}
    </div>
  );
}

export default NavigationItem;
